export const getCarsCount = (count: number | null) => {
  if (count === null) return "0 cars";
  const cars = count === 1 ? " car" : " cars";
  return `${count}${cars}`;
};
